module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_500_750.f9f67548.png";